import request from "@/http/request"
import {
    taskList,
    uploadQuestionFile,
    taskSave,
    taskChangeDelete,
    taskChangeWait,
    taskChangeWaitAgain,
    taskDownloadQuestion,
    taskDownloadOriFile,
} from '@/http/api'

export const taskListFn = (data) => {
    return request({
        url: taskList,
        data
    })
}
export const uploadQuestionFileFn = (data) => {
    return request({
        url: uploadQuestionFile,
        isUpload: true,
        data,
    })
}
export const taskSaveFn = (data) => {
    return request({
        url: taskSave,
        data
    })
}
export const taskChangeDeleteFn = (data) => {
    return request({
        url: taskChangeDelete,
        data
    })
}
export const taskChangeWaitFn = (data) => {
    return request({
        url: taskChangeWait,
        data
    })
}
export const taskChangeWaitAgainFn = (data) => {
    return request({
        url: taskChangeWaitAgain,
        data
    })
}
export const taskDownloadQuestionFn = (data) => {
    return request({
        url: taskDownloadQuestion,
        data
    })
}
export const taskDownloadOriFileFn = (data) => {
    return request({
        url: taskDownloadOriFile,
        data
    })
}